(function() {
	'use strict';

	angular.module('dutySheet').controller('ConfirmGDPrintTemplateCtrl',
			ConfirmGDPrintTemplateCtrl);

	function ConfirmGDPrintTemplateCtrl($uibModalInstance, modalParams) {
		var vm = this;
		vm.ctrlName = 'gdPrintTemplateCtrl';

		vm.model = {
			title : modalParams.title,
			clients : modalParams.clients || []
		};

		vm.onCloseClick = function() {
			$uibModalInstance.close(modalParams.close);
		};

		vm.onContinueClick = function() {
			$uibModalInstance.close(modalParams.clients);
		};

		vm.onlyOneSelected = function (selectedClient) {
      vm.model.clients.forEach(function(client) {
        if (client.clientCode !== selectedClient.clientCode) {
          client.isSelected = false;
        }
      });
    }
	}
}());
